import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import { formatPadding } from '../../styles';

interface HeaderProps {
  marginTop?: string;
}
export const Header = styled.div<HeaderProps>`
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '24px')};
`;

export const Heading = styled.p`
  color: ${COLORS.black};
  text-align: center;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 28px;
  font-style: normal;
  line-height: 38px;
  margin: 36px 0px 24px 0px;
  @media ${DEVICES.mobileL} {
    padding: 0px 24px 0px 24px;
  }
`;

export const ScreenContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const FormContainer = styled.div`
  margin-bottom: 48px;
  width: 450px;
  min-height: 663px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  padding: 48px 0px 48px 0px;
  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    div[class^='outlinedDropdownField__BoxContainer'] {
      margin-top: 15px !important;
      margin-bottom: 0 !important;
      margin: 0;
      width: 100%;
      .text {
        text-align: inherit;
      }
      span.text {
        font-size: 14px;
      }
    }
  }

  @media ${DEVICES.mobileL} {
    form {
      width: 350px !important;
    }
  }
  @media ${DEVICES.mobileM} {
    form {
      width: 330px !important;
    }
  }
  @media ${DEVICES.mobileS} {
    form {
      width: 300px !important;
    }
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  .marginLineBreak {
    margin: 36px 0;
  }
`;

export const CurrencyCalculatorWrapper = styled.div`
  padding: 24px;
  border: 1px solid ${COLORS.borderGrey};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const CurrencyCalculator = styled.div`
  .parent {
    text-align: start;
    max-height: 150px;
    display: flex;
    align-items: flex-start;
  }
  .parentflags {
    text-align: start;
    max-height: 150px;
    display: flex;
    align-items: flex-start;
    width: 40%;
  }
  .child {
    width: 40%;
  }
  .childFirst {
    width: 60%;
  }
  .conversionRate {
    padding: 24px 0px 24px 0px;
  }

  .currencyField {
    @extend .currency-field;
    .render-text-field {
      grid-row: 1 / span 1;
      grid-column: 1 / span 1;
      width: 200px !important;
      min-height: 50px;
      margin: initial;
      display: flex;
      align-items: center;
      .input-error-wrapper {
        padding-bottom: 10%;
        .ui.input {
          width: 100%;
          input {
            width: 100%;
            padding: 0 !important;
            border: none;
            color: ${COLORS.black};
            caret-color: ${COLORS.brandPrimary};
            font-family: ${FONT_FAMILY.hellix.regular};
            letter-spacing: 1.4px;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
      .error-msg {
        top: auto;
      }
    }
  }

  .flagImage {
    margin-top: 10%;
    float: right;
  }
  .feesInclude {
    color: ${COLORS.black};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
  .includeFees {
    float: none !important;
    margin-top: 2%;
  }
  .flagImageDestinationCurrency {
    float: right;
    margin-top: 30%;
  }
  .flag {
    margin-top: 20px !important;
    height: 50px;
    width: 80px;
  }
  #destination-currency {
    padding-top: 0px;
  }
  #source-currency {
    padding-top: 0px;
  }
  .dropdown-component {
    margin: 0;
    .input-error-wrapper {
      input {
        caret-color: ${COLORS.brandPrimary};
        margin: 8px 0px 0px 8px;
      }
      .visible {
        width: 200px;
      }
      .ui {
        width: 30px;
      }
      .ui.fluid.search.selection.dropdown {
        width: 120px;
        @media ${DEVICES.mobileL} {
          width: 60px;
        }
        .dropdown.icon {
          right: 50%;
          @media ${DEVICES.mobileL} {
            right: 10%;
          }
          top: 20px;
          padding: 0;
        }
      }
      .ui.visible {
        width: 200px;
      }
      .ui.visible.menu {
        width: 200px;
      }
      .ui.active.visible.selection.dropdown {
        width: 150px;
        .icon {
          right: 55% !important;
          top: 20px;
          padding: 0;
        }
        @media ${DEVICES.mobileXL} {
          width: 90px !important;
          .icon {
            right: 15% !important;
          }
          .menu {
            width: 120px !important;
            left: -24px !important;
            max-height: 160px;
            .item {
              padding: 10px 7px !important;
            }
          }
        }
      }
      .ui.dropdown {
        border: none !important;
        padding: 0px;
        height: 35px;
        width: 150px;
        input.search {
          padding: 0px !important;
        }
        .text {
          font-family: ${FONT_FAMILY.hellix.regular};
          font-style: normal;
          color: ${COLORS.black};
          padding-top: 0px;
          width: 60px;
          font-size: 24px;
          font-weight: 400;
        }
      }
    }
  }
  .conversionText {
    color: ${COLORS.textLightGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-top: 24px !important;
  }
`;

export const UserFormContainer = styled.div`
  margin: 48px 0px 24px 0px;
  .provideInfo {
    color: ${COLORS.black};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
  }
  .srcFunds {
    margin-top: 24px;
  }
  .reasonForTransfer {
    margin: 26px 0px 16px 0px;
  }
  .remittanceType {
    margin-bottom: 16px;
  }
  .remittanceType {
    margin: 26px 0px 16px 0px;
  }
  .customFields {
    .input-error-wrapper > div {
      width: 100%;
    }
    .input-error-wrapper > div > div > div {
      text-align: start !important;
    }
  }
  .reasonForTransferText {
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 24px;
  }
`;

export const AdditionalDetailsContainer = styled.div`
  .swiftFees {
    color: ${COLORS.textLightGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  .taxText {
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  .taxValue {
    color: ${COLORS.black};
    text-align: right;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px; /* 162.5% */
  }
  .includeFees {
    float: none !important;
  }
`;

export const AdditionalChargesText = styled.p`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  font-style: normal;
  line-height: 26px;
  margin-bottom: 24px;
`;

export const TextBoldMedium = styled.p`
  color: ${COLORS.black};
  text-align: right;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  font-style: normal;
  line-height: 26px;
`;

type DetailsContainerProps = {
  margin?: Array<number>;
};
export const DetailsContainer = styled.div<DetailsContainerProps>`
  white-space: nowrap;
  margin: ${({ margin }) => (margin ? formatPadding(margin) : '24px 0px 24px 0px')};
`;

export const DetailsContainerLeft = styled.div`
  display: inline-block;
  width: 80%;
`;

export const AddnDetailsContainerLeft = styled.div`
  display: inline-block;
  width: 60%;
`;
export const AddnDetailsContainerRight = styled.div`
  display: inline-block;
  width: 40%;
`;

export const TextGrey = styled.p`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const YouPayExactlyFinalAmountText = styled.p`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 28px;
  font-style: normal;
  line-height: 38px;
`;
export const DetailsContainerRight = styled.div`
  display: inline-block;
  width: 20%;
`;

export const DetailsText = styled.p`
  color: ${COLORS.darkBlue} !important;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px !important;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.133px;
  cursor: pointer;
  float: right;
`;

export const Details = styled.div`
  min-height: 350px;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 10px;

  .navigationContainer {
    justify-content: right;
    display: flex;
    margin: 0px 0px 16px 0px;
    .closeButton {
      grid-column: 3;
      cursor: pointer;
      justify-self: right;
      width: 16px;
      height: 16px;
    }
    @media ${DEVICES.mobileXL} {
      margin-top: 48px;
      .closeButton {
        justify-self: right;
        margin-right: 15px;
      }
    }
  }
  @media ${DEVICES.mobileL} {
    width: 100% !important;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 10px;
  }
`;

export const LineBreak = styled.div`
  border: 1px solid ${COLORS.borderBlue};
  opacity: 0.3704;
`;

export const NormalHorizonatlLine = styled.div`
  border: 1px solid ${COLORS.borderGrey};
`;

export const LineBreakLight = styled.div`
  border: 1px solid ${COLORS.borderGrey};
  opacity: 0.3704;
`;

export const DetailsSubContainer = styled.div`
  @media ${DEVICES.mobileL} {
    width: 100%;
    margin: 1%;
    padding-right: 15px;
  }
  .marginTB5 {
    margin-top: 5%;
    margin-bottom: 5%;
  }

  .textFinalAmount {
    color: ${COLORS.black};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px !important;
    font-weight: 700;
    letter-spacing: 0.175px;
  }
  .inlineContent {
    display: inline-block;
    vertical-align: middle;
  }
  .taxContainer {
    margin-left: 5%;
  }
`;

export const TimeLineContainer = styled.div`
  .timelineContainer {
    max-width: 900px;
    margin: 8px 0px 8px 0px;
    position: relative;
  }

  .timelineEvent {
    position: relative;
    display: flex;
    align-items: center;
    -webkit-align-items: start !important;
  }

  .timelineMarker {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    position: relative;
  }

  .timelineLine {
    position: absolute;
    left: 10px;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: black;
    z-index: 1;
  }
  .timelineLineStart {
    position: absolute;
    left: 10px;
    top: 20px;
    bottom: 0;
    width: 1px;
    background-color: black;
    z-index: 1;
  }

  .timelineIcon {
    font-size: 12px;
    color: white;
  }

  .timelineContentStart {
    z-index: 2;
    margin-left: 10px;
    width: 100%;
  }
  .timeLineBorder {
    border-top: 1px solid ${COLORS.borderGrey};
    border-bottom: 1px solid ${COLORS.borderGrey};
  }
  .timelineStartImage {
    margin: 7px 0px 0px 2px;
  }
  .maxHeight {
    height: 60%;
    @media ${DEVICES.mobileL} {
      height: 32%;
    }
  }
`;

type DetailsModalInfoContainerProps = {
  margin: Array<number>;
  padding: Array<number>;
};

export const DetailsModalInfoContainer = styled.div<DetailsModalInfoContainerProps>`
  margin: ${({ margin }) => formatPadding(margin)};
  padding: ${({ padding }) => formatPadding(padding)};
  text-align: start;
  max-height: 150px;
  display: flex;
`;

export const DetailsModalLeftContainer = styled.div`
  width: 60%;
  align-items: flex-start;
  img {
    cursor: pointer;
  }
  .upArrow {
    cursor: pointer;
    transform: rotate(180deg);
  }
  .downArrow {
    cursor: pointer;
  }
`;
export const DetailsModalRightContainer = styled.div`
  width: 40%;
  float: right;
  text-align: right;
`;
export const DetailsModalHeadingText = styled.p`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px !important;
  letter-spacing: 0.2px;
  margin-bottom: 24px;
`;

export const DetailsModalTextBold = styled.div`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 14px !important;
  letter-spacing: 0.175px;
`;

export const DetailsModalTextNormal = styled.div`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px !important;
  font-weight: 400;
  line-height: 24px;
`;

export const DetailsModalTextSmall = styled.div`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const DetailsModalWarningText = styled.div`
  color: ${COLORS.red};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const DetailsDisclaimerText = styled.p`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

type ModalContainerProps = {
  height?: number;
  width?: number;
  buttonWidth?: number;
  buttonTopMargin?: number;
  containerMarginTop?: number;
};

export const ModalContainer = styled.div<ModalContainerProps>`
  background: ${COLORS.white};
  width: ${({ width }) => width}px;
  border-radius: 4px;
  min-height: ${({ height }) => height}px;
  gap: 32px;
  padding: 24px 16px 32px 16px;
  .modalBodyContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: ${(props) => props.containerMarginTop}px;
  }
`;

export const OnGoingTransferHeading = styled.h2`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  font-style: normal;
  line-height: 26px;
`;

export const OnGoingTransferSubHeading = styled.h2`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const CardSubContainer = styled.div`
  width: 550px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  padding: 48px;

  @media ${DEVICES.mobileL} {
    margin-top: 30px;
    width: 350px;
    padding: 15px;
  }
  @media ${DEVICES.mobileM} {
    margin-top: 30px;
    width: 335px;
    padding: 32px 16px;
  }
  @media ${DEVICES.mobileS} {
    margin-top: 30px;
    width: 335px;
    padding: 32px 16px;
  }
`;
export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border: 1px solid ${COLORS.borderGrey};
  background-color: ${COLORS.white};

  border-radius: 4px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  .proceed-icon {
    width: 20px;
  }
`;
export const IconContainer = styled.div`
  margin-right: 16px;
  width: 20px;
`;
export const ContentContainer = styled.div`
  flex: 1;
`;

export const PendingKYCModalContainer = styled.div`
  display: flex;
  background-color: ${COLORS.white};
  justify-content: flex-end;
  align-items: flex-end;
  padding: 32px 16px;
  gap: 24px;
  border-radius: 10px;
  width: 450px;
  flex-direction: column;
  .heading-icon-container {
    width: 100%;
    display: grid;
    grid-template-columns: 25fr 1fr;
    align-items: center;
    justify-content: center;
    .close-icon {
      float: right;
      justify-self: right;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .__heading {
      width: 100%;
      text-align: center;
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 38px;
    }
  }
  .modal-body-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    gap: 24px;

    .__sub-heading {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      color: ${COLORS.textGrey};
      text-align: center;
    }
  }
`;

export const SWIFTChargesContainer = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${COLORS.borderGrey};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: ${COLORS.lightShadedGrey};
  padding: 12px 16px;
`;
export const InfoIcon = styled.img`
  align-self: flex-start;
`;
export const SwiftCharges = styled.div`
  margin-left: 10px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  line-height: 22px;
`;
